<template>
  <div>
    <footer class="footer-faq">
      <div class="container">
        <div class="row">
          <div class="col-12">
            <h2 class="footer-title">Preguntas frecuentes</h2>
          </div>
        </div>

        <div class="row footer-faq-row">
          <div class="col-12 col-md-6">
            <div class="faq-item">
              <h3>¿Cuántos puntos vale mi ticket?</h3>
              <p>Cada peso registrado equivale a 1 punto.</p>
            </div>

            <div class="faq-item">
              <h3>¿Cuántas veces puedo participar?</h3>
              <p>
                Todas las veces que quieras, registrando tickets diferentes.
                Pero solo podrás ganar una vez durante toda la vigencia de la
                promoción.
              </p>
            </div>
          </div>

          <div class="col-12 col-md-6">
            <div class="faq-item">
              <h3>¿Cómo se eligen los ganadores?</h3>
              <p>
                Cada semana se seleccionan los 20 participantes con más puntos
                acumulados.
              </p>
            </div>

            <div class="faq-item">
              <h3>¿Cómo recibiré mi premio?</h3>
              <p>
                Los premios se enviarán a la dirección registrada en tu cuenta.
              </p>
            </div>
          </div>
        </div>

        <div class="row footer-legal-row">
          <div class="col-12">
            <p class="footer-legal-link">
              <a href="/tyc.pdf" target="_blank" rel="noopener noreferrer">
                Ver Términos y condiciones
              </a>
            </p>

            <p class="footer-legal-link">
              <a href="https://pautacreativa.com.mx/aviso-de-privacidad/" target="_blank" rel="noopener noreferrer">
                Ver Aviso de privacidad
              </a>
            </p>

            <p class="footer-legal-text">
              Si tienes alguna duda, contáctanos al
              teléfono: <a href="tel:+55 5350 1255" class="blanco">55 5350 1255</a>
            </p>

            <p class="footer-legal-text">
              Promoción válida del 23 de marzo al 31 de mayo de 2026
            </p>
          </div>
        </div>
      </div>
    </footer>

    <span class="loading" v-bind:class="{ active: this.$store.state.loading }">
      <img src="../assets/imgs/DualRing-1.1s-200px.svg" alt="loading" />
    </span>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  methods: {},
};
</script>

<style scoped>
.footer-faq {
  background: #ef1c0f;
  padding: 42px 0 40px;
}

.footer-title {
  color: #ffffff;

  line-height: 1;
  font-weight: 800;
  margin-bottom: 26px;
}

.footer-faq-row {
  margin-bottom: 42px;
}

.faq-item {
  margin-bottom: 28px;
  max-width: 430px;
}

.faq-item h3 {
  color: #ffffff;

  line-height: 1.15;
  font-weight: 800;
  margin-bottom: 6px;
}

.faq-item p {
  color: #ffffff;

  line-height: 1.15;
  font-weight: 400;
  margin-bottom: 0;
}

.footer-legal-row {
  margin-top: 10px;
}

.footer-legal-link,
.footer-legal-text {
  margin-bottom: 2px;
  line-height: 1.2;
}

.footer-legal-link a,
.footer-legal-text {
  color: #ffffff;
  font-size: 12px;
  font-weight: 400;
}

.footer-legal-link a {
  text-decoration: underline;
}

.footer-legal-link a:hover {
  color: #ffffff;
  opacity: 0.9;
}

@media (max-width: 991px) {
  .footer-faq {
    padding: 32px 0 30px;
  }

  .footer-title {
    font-size: 34px;
    margin-bottom: 22px;
  }

  .faq-item {
    max-width: 100%;
    margin-bottom: 24px;
  }

  .faq-item h3 {
    font-size: 20px;
  }

  .faq-item p {
    font-size: 18px;
  }
}

@media (max-width: 767px) {
  .footer-title {
    font-size: 30px;
  }

  .faq-item h3 {
    font-size: 18px;
  }

  .faq-item p {
    font-size: 16px;
    line-height: 1.2;
  }

  .footer-legal-link a,
  .footer-legal-text {
    font-size: 11px;
  }
}
</style>